import { UpgradeModalState } from './types';
import {
	CLEAR,
	DIFFERENT_FOR_RETURN_FLIGHT,
	DISABLE,
	DisableAction,
	SET_ALL_SERVICES,
	SET_SERVICES,
	SetServicesAction,
	SET_BAGGAGE_TAB,
	SetBaggageTabAction,
	SET_CURRENT_SLIDE,
	SetCurrentSlideAction,
	SetAllServicesAction,
	ActionTypes
} from './actions';
import { getMinCountServiceKey, getSelectedServicesByType } from './utils';

const initialState: UpgradeModalState = {
	services: [],
	selectedServices: [],
	differentForReturnFlight: false,
	disabled: false,
	baggageTab: null,
	currentSlide: 0,
	passengers: null,
	segmentIds: [],
	upgradableBaggage: [],
	gdsServicesCalculatedLimitInfo: {}
};

export const upgradeModalReducer = (
	state: UpgradeModalState = initialState,
	action: ActionTypes
): UpgradeModalState => {
	if (action.type !== DISABLE && action.type !== SET_CURRENT_SLIDE && state.disabled) {
		return state;
	}

	switch (action.type) {
		case CLEAR:
			return {
				...state,
				baggageTab: state.initialBaggageTab ?? state.baggageTab,
				currentSlide: 0,
				selectedServices: state.selectedServices.map(selectedService => {
					return {
						...selectedService,
						// значение сбрасываем на кол-во оплаченных позиций либо на 0
						count: state.services.find(service => service.id === selectedService.serviceId)
							? state.passengers
									.find(p => p.id === selectedService.passengerId)
									?.services.find(
										s =>
											s.serviceId === selectedService.serviceId &&
											s.segmentIds.some(s => selectedService.segmentIds.includes(s))
									)?.confirmedCount ?? 0
							: selectedService.count
					};
				})
			};
		case DIFFERENT_FOR_RETURN_FLIGHT:
			const newValue = !state.differentForReturnFlight;

			const minCountByServiceMap = new Map<string, number>();
			const segmentCoverageByKey = new Map<string, Set<string>>();

			state.selectedServices.forEach(selectedService => {
				const key = getMinCountServiceKey(selectedService);

				const prevMin = minCountByServiceMap.get(key);
				minCountByServiceMap.set(
					key,
					prevMin === undefined ? selectedService.count : Math.min(prevMin, selectedService.count)
				);

				let covered = segmentCoverageByKey.get(key);
				if (!covered) {
					covered = new Set<string>();
					segmentCoverageByKey.set(key, covered);
				}
				selectedService.segmentIds.forEach(id => covered.add(id));
			});

			segmentCoverageByKey.forEach((covered, key) => {
				const isAllSegments = state.segmentIds.every(id => covered.has(id));
				if (!isAllSegments) {
					minCountByServiceMap.set(key, 0);
				}
			});

			return {
				...state,
				differentForReturnFlight: newValue,
				selectedServices: state.selectedServices.map(selectedService => ({
					...selectedService,
					count: minCountByServiceMap.get(getMinCountServiceKey(selectedService)) ?? selectedService.count
				}))
			};
		case SET_SERVICES:
			const selectedServices = getSelectedServicesByType(state, action as SetServicesAction);

			return { ...state, selectedServices };

		case SET_BAGGAGE_TAB:
			return {
				...state,
				baggageTab: (action as SetBaggageTabAction).payload,
				currentSlide: 0
			};

		case SET_CURRENT_SLIDE:
			return {
				...state,
				currentSlide: (action as SetCurrentSlideAction).payload
			};

		case SET_ALL_SERVICES:
			return {
				...state,
				selectedServices: [...(action as SetAllServicesAction).payload.map(service => ({ ...service }))]
			};
		case DISABLE:
			return {
				...state,
				disabled: (action as DisableAction).payload
			};
	}

	return state;
};
